/**
 * Gate fitur premium di sisi web (plan 21, amandemen 2026-08-23;
 * Fase 2 plan 23: gerbang berbasis entitlement per akun, bukan flag global).
 *
 * Server menegaskan entitlement di setiap endpoint (403 PremiumRequired)
 * — helper ini hanya mengatur visibilitas UI, bukan keamanan.
 */

import { PAYWALL_ENABLED } from '@funpaper/shared';
import {
  ACTIVITY_LIST,
  HARIAN_ACTIVITY_LIST,
  type Activity,
} from '@/lib/activity';

/** Tier sesi — satu-satunya basis gerbang UI premium mulai Fase 2. */
export type SessionTier = 'guest' | 'free' | 'premium';

export function tierForSession(opts: {
  isGuest: boolean;
  isPremium: boolean;
}): SessionTier {
  if (opts.isGuest) return 'guest';
  return opts.isPremium ? 'premium' : 'free';
}

/** Opsi aktivitas onboarding berbasis tier (premium = 15 kanonik). */
export function activityOptionsForTier(tier: SessionTier): readonly Activity[] {
  return tier === 'premium' ? ACTIVITY_LIST : HARIAN_ACTIVITY_LIST;
}

/** Halaman edit-preferensi hanya untuk tier premium. */
export function preferencesVisibleForTier(tier: SessionTier): boolean {
  return tier === 'premium';
}

/** @deprecated Fase 2 plan 23: pakai tierForSession + activityOptionsForTier. */
export function isPremiumPreferencesEnabled(
  paywallEnabled: boolean,
  isGuest: boolean,
): boolean {
  return paywallEnabled && !isGuest;
}

/** @deprecated Fase 2 plan 23: pakai activityOptionsForTier. */
export function activityOptionsForSession(
  paywallEnabled: boolean,
  isGuest: boolean,
): readonly Activity[] {
  return isPremiumPreferencesEnabled(paywallEnabled, isGuest)
    ? ACTIVITY_LIST
    : HARIAN_ACTIVITY_LIST;
}

/** @deprecated Fase 2 plan 23: pakai preferencesVisibleForTier. */
export function preferencesVisibleForSession(isGuest: boolean): boolean {
  return isPremiumPreferencesEnabled(PAYWALL_ENABLED, isGuest);
}
